import React, { useContext, useEffect, useMemo, useState } from "react";
import RecentOrder from "modules/nextcall/RecentOrder";
import ScalpImage from "./ScalpImage";
import CardDiv from "modules/common/card-div/CardDiv";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import SubTabs from "./SubTabs";
import Message from "assets/svgs/message";
import SendComment from "./SendComment";
import OrderCards from "./OrderCards";
import { LeadPop } from "modules/lead_Detail_pop_up/LeadPop";
import { CustomerProps } from "./ShowCustomer";

function EngagementContent({activeTab, setActiveTab}) {
  const [floatingMessage, setFloatingMessage] = useState(false);
  const [messageFloater, setMessageFloater] = useState(true);
  const [comment, setComment] = useState();
  const [visible, setVisible] = useState(false);
  const [sortedCustomerData, setSortedCustomerData] = useState([]);

  const currentUrl = window.location.href.split("/");
  const { customer, nextCall, actionableTabs, caseId, booking, setBooking } = useContext(CustomerProps);

  useEffect(() => {
    setSortedCustomerData(
      customer.orders.sort((orderA, orderB) => {
        return new Date(orderB.created_at) - new Date(orderA.created_at);
      })
    );
  }, [customer]);

  const handleFloatingMessageToggle = () => {
    setFloatingMessage(!floatingMessage);
  };

  return (
    <div
      style={{ height: actionableTabs ? "62vh" : "85%", overflowY: "scroll" }}
      className="scrollable-container"
    >
      <div className="d-flex gap-3 flex-column pe-3 ps-1">
        <Row>
          {/* {offline ? null : ( */}
            <Col md={actionableTabs ? 4 : 3}>
              <CardDiv
                component={
                  <RecentOrder
                    // nextCall={nextCall}
                    customer={customer}
                    // setBooking={setBooking}
                    orders={sortedCustomerData}
                  />
                }
              />
            </Col>
          {/* )} */}
          <Col md={actionableTabs ? 8 : 9} className="ps-0">
            <CardDiv component={<OrderCards orders={sortedCustomerData} />} />
          </Col>
        </Row>
        <Row>
          <Col md={actionableTabs ? 4 : 3}>
            <CardDiv component={<ScalpImage />} />
          </Col>
          <Col md={actionableTabs ? 8 : 9} className="ps-0">
            <SubTabs
              customer={customer}
              setMessageFloater={setMessageFloater}
              bookings={booking}
            />
          </Col>
        </Row>

        <Row className="my-1 me-1 d-flex align-items-stretch"></Row>
      </div>
      {messageFloater && (
        <div
          style={{ bottom: 30, right: 130 }}
          className={`position-fixed z-index-9000 bg-white d-flex gap-3 align-items-center p-2 ps-3 shadow-lg rounded-5 ${
            floatingMessage ? `border border-secondary` : ""
          }`}
        >
          {floatingMessage && (
            <SendComment
              case_id={caseId}
              comment={comment}
              setComment={setComment}
            />
          )}
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip">Add Comment</Tooltip>}
          >
            <div
              onClick={handleFloatingMessageToggle}
              className={floatingMessage ? "ms-2" : ""}
            >
              <Message floating={true} />
            </div>
          </OverlayTrigger>
        </div>
      )}

      {currentUrl.includes("lead-details") ||
      currentUrl.includes("next-call") ? (
        <div>{<LeadPop visible={visible} />}</div>
      ) : null}
    </div>
  );
}

export default EngagementContent;
